// extracted by mini-css-extract-plugin
export default {"content":"titleScreen_content__zRtH7","text_block":"titleScreen_text_block__eNcKo","button_click":"titleScreen_button_click__+10JR"};